import React, { useState } from "react";
import { OrderTableQuery } from "../../../orders/models";
import { useGetOrdersQuery } from "../../../orders/queries";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { Table, Title } from "../../../../components";
import { Column } from "react-data-grid";
import { getTablePageCount } from "../../../../helpers/tableHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { useNavigate } from "../../../../helpers/navigationHelpers";
import { CPOrder } from "../../../../api/models/unified";

interface Props {
  serviceObjectId: string;
}

const defaultTableQuery: OrderTableQuery = {
  page: 1,
  pageSize: 10,
};

const ServiceObjectOrdersTable: React.FC<Props> = (
  props,
): React.ReactElement => {
  const { serviceObjectId } = props;
  const { tOrder, tServiceObject } = useCustomTranslation();
  const navigate = useNavigate();

  const [queryParams, setQueryParams] = useState<OrderTableQuery>({
    ...defaultTableQuery,
    serviceObjectId,
  });

  const query = useGetOrdersQuery(queryParams);

  const columns: Column<CPOrder>[] = [
    {
      key: "created",
      name: tOrder("created"),
      renderCell: ({ row }) => renderDate(row.created),
      sortable: true,
    },
    { key: "code", name: tOrder("code"), sortable: true },
    {
      key: "state",
      name: tOrder("state"),
      renderCell: ({ row }) => tOrder(`state_${row.state}`),
      sortable: true,
    },
    { key: "oneLinerAddress", name: tOrder("address"), sortable: true },
  ];

  return (
    <div className="mt-14">
      <Title className="mb-2.5 ml-5" title={tServiceObject("orders")} />
      <Table
        columns={columns}
        data={query.data?.data ?? []}
        onTableQueryChange={setQueryParams}
        queryParams={queryParams}
        pageCount={getTablePageCount(
          query.data?.total ?? 1,
          queryParams.pageSize,
        )}
        loading={query.isLoading}
        onRowClick={(item) => navigate.goTo(`orders/${item.id}`)}
        detailMode
      />
    </div>
  );
};

export default ServiceObjectOrdersTable;
